export default __webpack_public_path__ + "static/media/hbA1c.19b8728e.svg";